var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticClass:"py-7"},[(_vm.orderTypeButtonsEnabled)?_c('div',{staticClass:"mb-6"},[_c('OrderTypeButtons')],1):_vm._e(),(!_vm.$store.getters['app/isQrMenu'])?_c('main-slider'):_vm._e(),(_vm.$store.getters['aggregator/isAggregator'])?[_c('MerchantList')]:[_c('catalog-sections')],_c('geo-map')],2)
}
var staticRenderFns = []

export { render, staticRenderFns }